import apigeeIntegration from "./self-service-adapter";
const fixedOrderSearch = apigeeIntegration("/fixed-order-search/v2");
const getSubscriptionOrders = () => fixedOrderSearch.get("/orders");

export default {
	getSubscriptionOrders,
};
